// Register Interest Modal
const ModalMap = {
    'register-interest-modal': {
        button: 'register-interest',
        onOpenFunc: () => {
            document.querySelectorAll('svg.top-tri, svg.bottom-tri').forEach((svg) => {
                if (window.innerWidth >= 640) {
                    svg.classList.add('!w-full');
                }
            });
        },
        onCloseFunc: () => {
            document.querySelectorAll('svg.top-tri, svg.bottom-tri').forEach((svg) => {
                svg.classList.remove('!w-full');
            });
        }
    },
    'presentedby-modal': {
        button: 'presentedby',
    }
};

function handleDialogClose(modal) {
    modal.dataset.open = 'false';
    const modalConfig = ModalMap[modal.id];
    modalConfig?.onCloseFunc && modalConfig.onCloseFunc();
}

function handleDialogOpen(modal) {
    modal.showModal();
    modal.dataset.open = 'true';

    const modalConfig = ModalMap[modal.id];
    modalConfig?.onOpenFunc && modalConfig.onOpenFunc();
}

window.addEventListener('load', () => {
    for (let modalId in ModalMap) {
        const modal = document.getElementById(modalId);

        if (modal) {
            const modalConfig = ModalMap[modalId];
            const buttonName = modalConfig.button;
            const closeModalButton = modal.querySelector('button[name="close-button"]');

            document.querySelectorAll(`button[name="${buttonName}"]`).forEach((button) => {
                button.addEventListener('click', () => handleDialogOpen(modal));
            });

            closeModalButton.addEventListener('click', () => modal.close());
            modal.addEventListener('close', () => {
                handleDialogClose(modal);
            });
        }
    }
});